<template>
   
        <div class="card shadow bg-light"> 
            <div class="card-header bg-white">
                <h2 class="text-center p-2 text-uppercase text-dblue"><strong>Contact Us</strong></h2>	
                <div class="row text-center">
                    <div class="col-md-4">
                        <a class="text-black" href="https://www.google.com/maps/place/Executives+on+the+Web/@52.6835969,-1.8287234,19z/data=!3m1!4b1!4m5!3m4!1s0x4870a78f00000001:0x2272372664518f27!8m2!3d52.6835969!4d-1.8281762"  target="_blank" rel="noopener">
                        <i class="fa fa-map-marker fa-lg pr-2 text-dblue" aria-hidden="true"></i>Lichfield, WS13 6QG </a>
                    </div>
                    <div class="col-md-4">
                        <a href="mailto:customerservices@collsys.co.uk" class="text-black">
                        <i class="fa fa-envelope fa-lg pr-2 text-dblue" aria-hidden="true"></i>customerservices@collsys.co.uk</a>
                    </div>
                    <div class="col-md-4">
                        <a href="tel:+44(0)1212 956305" class="text-black">
                        <i class="fa fa-phone fa-lg pr-2 text-dblue" aria-hidden="true"></i>+44(0)1212 956305</a>
                    </div>
                </div>			
            </div>

            <div class="card-body">		
                <form @submit.prevent="send">
                    <div v-if="form.isCreated" class="alert alert-success alert-dismissible fade show" role="alert">
                        <span>Thank you for contacting us. We will contact you shortly.</span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div> 
                    <div class="row">		
                        <div class="col-md-6">																									
                            <div class="form-group">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend ">
                                        <div class="input-group-text bg-dblue border-0"><i class="fa fa-user fa-lg text-white"></i></div>
                                    </div>
                                    <input type="text" class="form-control"  id="name" name="name" v-model="form.name"  @keydown="errors.name = null" placeholder="Your full Name">                             
                                </div>
                                <span  v-if="errors && errors.name" class="text-danger small">{{errors.name[0]}}</span>
                            </div>
                            <div class="form-group">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text bg-dblue border-0"><i class="fa fa-envelope fa-lg text-white"></i></div>
                                    </div>
                                    <input type="email" class="form-control" id="email" name="email" v-model="form.email" @keydown="errors.email = null" placeholder="Your Email">
                                </div>
                                <span  v-if="errors && errors.email" class="text-danger small">{{errors.email[0]}}</span>
                            </div>					
                            <div class="form-group">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text bg-dblue border-0"><i class="fa fa-phone fa-lg text-white"></i></div>
                                    </div>
                                    <input type="text" class="form-control" id="phone" name="phone" v-model="form.phone"  @keydown="errors.phone = null" placeholder="Your Phone Number" >
                                    <span  v-if="errors && errors.phone" class="text-danger text-sm">{{errors.phone[0]}}</span>
                                </div>
                            </div>																					
                        </div> <!-- end col-md-6 -->
                        <div class="col-md-6">
                        <div class="form-group">
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text bg-dblue border-0"><i class="fa fa-building fa-lg text-white"></i></div>
                                </div>
                                <input type="company" class="form-control" name="organisation" v-model="form.organisation" placeholder="Your Organisation Name">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text bg-dblue border-0"><i class="fa fa-building fa-lg text-white"></i></div>
                                </div>
                                <select v-model="form.sender_type" class="form-control" name="sender_type" >
                                    <option disabled value="">Select Organisation Type</option>
                                    <option value="School">School</option>
                                    <option value="College">College</option>
                                    <option value="EBP">EBP</option>
                                    <option value="Work Experience Provider">Work Experience Provider</option>
                                </select>								
                            </div>		
                        </div>
                    </div>                   
                    </div> <!-- end row -->
                     <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                            <label><b>I would like information on: </b></label><br>
                            <div class="form-check-inline">
                                <label class="form-check-label">
                                <input type="checkbox" class="form-check-input" name="collsys" value="collsys" v-model="form.collsys">CollSys
                                </label>&emsp;
                            </div>
                            <div class="form-check-inline">
                                <label class="form-check-label">
                                <input type="checkbox" class="form-check-input" name="wex" value="wex" v-model="form.wex">Work Placement
                                </label>&emsp;
                            </div>
                            <div class="form-check-inline">
                                <label class="form-check-label">
                                <input type="checkbox" class="form-check-input" name="crm" value="crm" v-model="form.crm">CRM
                                </label>&emsp;
                            </div>
                            <div class="form-check-inline">
                                <label class="form-check-label">
                                <input type="checkbox" class="form-check-input" name="enrichment" value="enrichment" v-model="form.enrichment">Enricment
                                </label>&emsp;
                            </div> 
                            <div class="form-check-inline">
                                <label class="form-check-label">
                                <input type="checkbox" class="form-check-input"  name="careers" value="careers" v-model="form.careers" >Careers
                                </label>&emsp;
                            </div> 
                            <div class="form-check-inline">
                                <label class="form-check-label">
                                <input type="checkbox" class="form-check-input" name="demo" value="demo" v-model="form.demo" >Demonstration
                                </label>
                            </div> 
                        </div>

                            <div class="form-group">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text bg-dblue border-0"><i class="fa fa-pencil fa-lg text-white"></i></div>
                                    </div>
                                    <textarea class="form-control" name="message" id="message" v-model="form.message" @keydown="errors.message = null" placeholder="Your message"></textarea>
                                </div>
                                <span  v-if="errors && errors.message" class="text-danger small">{{errors.message[0]}}</span>
                            </div>
                            <div class="form-group text-center">
                                <button v-if="form.isSubmitting" class="btn btn-primary rounded-pill" type="button" disabled>
                                    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                    <span class="sr-only">Sending...</span>
                                </button>
                               <!--  <button v-else @click.prevent="send" class="btn btn-edit rounded-pill">SEND MESSAGE</button> -->
                        
                                <button v-else @click.prevent="sendMessage" type="submit" class="btn btn-edit rounded-pill"> <i class="fa fa-paper-plane pr-2"></i>SEND MESSAGE</button>
                            </div>
                        </div>
                    </div>				
                </form>		
            </div>
         </div> 
</template>

<script>
 export default {
    props: {       
          csrfToken: String
      },
    data() {
       
        return {
            form: {
                isSubmitting: false,
                isCreated: false,
                sender_type: '', 
            },
            success: false,
            errors:[],
            sender_type: '', 
            error: undefined,
        }
    },

    methods: {
       sendMessage(){     
            this.form.isSubmitting = true;
            axios.post('/contact-form-send', this.form)
                .then(response => { 
                    this.form.isSubmitting = true;             
                    this.form = {};
                    this.form.isCreated = true;
                    this.errors = [];
                    setTimeout(() => this.form.isCreated = false, 5000);
                }).catch(error => {
                   
                    if (error.response && error.response.status === 422) {
                        this.errors =error.response.data.errors;
                    } else {
                        console.log(error);
                        this.error = 'Unable to send the message';
                    }                     
                }).finally(() => {
                        // disable loader
                    this.form.isSubmitting = false;                   
                });                           
            }       
        }
    }
 

</script>

